export enum WITHHOLDING_TAX_CODE {
  'W01' = 0.05,
  'W04' = 0.02,
  'W06' = 0.02,
  'W25' = 0.02
};

